import React from "react"

const SystemSettingsContext = React.createContext({})

const { Provider, Consumer } = SystemSettingsContext

export { Provider, Consumer, SystemSettingsContext }
